<template>
  <div class="preview-container">
    <div class="preview-details">
      <small class="float-right characters-count">
        <span class="characters-count-span">characters: {{characterCount}}, </span>
        <span class="credit-count-span">
          credits: <span :class="['credits', { ['multi-credits']: totalCredits > 1 }]">{{totalCredits}}</span>
        </span>
      </small>
    </div>

    <div class="preview-message">
      {{previewMessage}}
    </div>

    <div v-if="invalidCharacters && invalidCharacters.length" class="invalid-alert callout">
      invalid {{character}} removed: <span class="invalid-character">{{invalidCharacters.join(' ')}}</span>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: {
      invalidCharacters: Array,
      messageModuleName: String,
    },

    data() {
      return {
        stop_message: ' Reply STOP 505R to cancel',
        characters: '',
      }
    },

    methods: {

    /**
     * Replaces %{MMS_LINK} in text with mockUrl to display in preview.
     * @function
     * @param {string} preview - Text received to replace %{MMS_LINK} tag with mockUrl for preview
     * @returns {string} parsedPreview - text without first instance of %{MMS_LINK} replaced with mockUrl
     * 
     * @example 
     * let preview = "Here's a sample text with %{MMS_LINK} in it"
     * parsedPreview(preview);
     * @returns "Here's a sample text with https://d.erll.co/3FIrfz5 in it"
     *
     */

      parsedPreview(preview) {
        const mmsStub = "%{MMS_LINK}",
              mmsLinkStartIdx = preview.indexOf(mmsStub),
              mmsLinkEndIdx = mmsLinkStartIdx + mmsStub.length;
        return mmsLinkStartIdx !== -1 ? `${preview.slice(0,mmsLinkStartIdx)}${this.mockUrl}${preview.slice(mmsLinkEndIdx)}` : preview;
      }
    },

    computed: {
      character: function () {
        const invalidLength = this.invalidCharacters?.length || null,
          text = invalidLength > 1 ? 'characters' : 'character'
        return invalidLength ? text : ''
      },

      previewMessage: function () {
        const stopText = this.currentMerchant?.stop_text || '',
          parsedPreview = (this.mmsAsLink || this.adAsLink) ? this.parsedPreview(this.updatedSmsContent) : this.updatedSmsContent, 
          preview = this.extensionType > 0 ? `${parsedPreview} ${this.mockUrl} ${stopText}` : parsedPreview + stopText
        return preview
      },

      ...mapState({
        adAsLink (state, getters) { return getters[`${this.messageModuleName}/adAsLink`] },
        characterCount (state) { return state[this.messageModuleName]?.characterCount },
        credits (state) { return state[this.messageModuleName]?.credits },
        currentMerchant (state) { return state.currentMerchant },
        extensionType (state) { return state[this.messageModuleName]?.extensionType },
        mmsAsLink (state, getters) { return getters[`${this.messageModuleName}/mmsAsLink`] },
        mockUrl (state) { return state[this.messageModuleName]?.mockUrl },
        totalCredits (state, getters) { return getters[`${this.messageModuleName}/totalCredits`] },
        updatedSmsContent (state) { return state[this.messageModuleName]?.updatedSmsContent },
      })
    },
  }
</script>
